import { DeleteNotificationTemplate, DeleteNotificationTemplateComplete, DeleteNotificationTemplateFailed } from './notification-delete.action';
import { LoadNotifications, LoadNotificationsCompleted, LoadNotificationsFailed, LoadNotificationTemplates, LoadNotificationTemplatesCompleted, LoadNotificationTemplatesFailed } from './notification-load.action';
import { SelectNotification, SelectNotificationCompleted, SelectNotificationFailed } from './notification-select.action';
import { SendNotifications, SendNotificationsCompleted, SendNotificationsFailed } from './notification-send.action';
import {
  CreateNotificationTemplate,
  UpdateNotification,
  UpdateNotificationCompleted,
  UpdateNotificationFailed,
  UpdateNotificationsReadState,
  UpdateNotificationsReadStateCompleted,
  UpdateNotificationTemplate,
  UpdateNotificationTemplateComplete,
  UpdateNotificationTemplateFailed,
 } from './notification-update.action';

export { NotificationActionType } from './notification-action-type.enum';

export { LoadNotifications, LoadNotificationsCompleted, LoadNotificationsFailed } from './notification-load.action';
export { SelectNotification, SelectNotificationCompleted, SelectNotificationFailed } from './notification-select.action';
export {
  UpdateNotification,
  UpdateNotificationsReadState,
  UpdateNotificationCompleted,
  UpdateNotificationsReadStateCompleted,
  UpdateNotificationFailed,
} from './notification-update.action';

export { SendNotifications, SendNotificationsCompleted, SendNotificationsFailed } from './notification-send.action';

export type NotificationActions =

  LoadNotifications |
  LoadNotificationsCompleted |
  LoadNotificationsFailed |
  LoadNotificationTemplates |
  LoadNotificationTemplatesCompleted |
  LoadNotificationTemplatesFailed |

  UpdateNotification |
  UpdateNotificationsReadState |
  UpdateNotificationCompleted |
  UpdateNotificationsReadStateCompleted |
  UpdateNotificationFailed |
  CreateNotificationTemplate |
  UpdateNotificationTemplate |
  UpdateNotificationTemplateComplete |
  UpdateNotificationTemplateFailed |

  DeleteNotificationTemplate |
  DeleteNotificationTemplateComplete |
  DeleteNotificationTemplateFailed |

  SelectNotification |
  SelectNotificationCompleted |
  SelectNotificationFailed |

  SendNotifications |
  SendNotificationsCompleted |
  SendNotificationsFailed;
